module.exports = __webpack_public_path__ + "img/var_02_line_left.7dcb2c29.png";